import { useState } from "react";

// ✅ Create React App (Webpack) way to load all images from a folder
const imageContext = require.context("../assets/NewYear26", false, /\.(png|jpe?g|gif|webp)$/);

const photos = imageContext.keys().map((path, index) => ({
  id: index + 1,
  url: imageContext(path),
  caption: path
    .replace("./", "")           // remove leading ./
    .replace(/\.[^.]+$/, "")     // remove file extension
    .replace(/[-_]/g, " "),      // replace dashes/underscores with spaces
}));

export default function EventGallery() {
  const [selected, setSelected] = useState(null);

  const navigate = (dir) => {
    const idx = photos.findIndex((p) => p.id === selected.id);
    setSelected(photos[(idx + dir + photos.length) % photos.length]);
  };

  return (
    <div style={{ maxWidth: 1100, margin: "0 auto", padding: "40px 20px", fontFamily: "sans-serif" }}>

      {/* <style>{`
        .photo-grid { columns: 3; column-gap: 12px; }
        @media (max-width: 768px) { .photo-grid { columns: 2; } }
        @media (max-width: 480px) { .photo-grid { columns: 1; } }
        .photo-item img { transition: transform 0.3s; }
        .photo-item:hover img { transform: scale(1.03); }
      `}</style> */}


<style>{`
  .photo-grid { columns: 3; column-gap: 12px; }
  @media (max-width: 768px) { .photo-grid { columns: 2; } }
  @media (max-width: 480px) { .photo-grid { columns: 1; } }
  .photo-item img { transition: transform 0.3s; }
  .photo-item:hover img { transform: scale(1.03); }

  /* Add these */
  .lightbox-img {
    margin-top: 50px;
    width: 90%;
    max-height: 60vh;
    object-fit: contain;
  }
  @media (orientation: landscape) {
    .lightbox-img {
      margin-top: 10px;   /* less top margin in landscape */
      max-height: 20vh;   /* smaller height so X button is visible */
      width: 30%;         /* narrower so it fits */
    }
  }
`}</style>
      {/* Header */}
      <h1 style={{ textAlign: "center", fontSize: 32, marginBottom: 8 }}>
        Chinese New Year Celebration
      </h1>
      <p style={{ textAlign: "center", color: "#888", marginBottom: 32 }}>
        1 March 2026 · Reading Chinese School
      </p>

      {/* Photo Grid */}
      {photos.length === 0 ? (
        <p style={{ textAlign: "center", color: "#aaa" }}>
          No photos found. Add images to <code>src/assets/events/</code> folder.
        </p>
      ) : (
        <div className="photo-grid">
          {photos.map((photo) => (
            <div
              key={photo.id}
              className="photo-item"
              onClick={() => setSelected(photo)}
              style={{ breakInside: "avoid", marginBottom: 12, cursor: "pointer", overflow: "hidden" }}
            >
              <img src={photo.url} alt={photo.caption} style={{ width: "100%", display: "block" }} />
            </div>
          ))}
        </div>
      )}

      {/* Lightbox */}
      {selected && (
        <div
          onClick={() => setSelected(null)}
          style={{
            position: "fixed", inset: 0,
            background: "rgba(0,0,0,0.9)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 1000, padding: 20,
          }}
        >
          <div onClick={(e) => e.stopPropagation()} style={{ position: "relative", maxWidth: 860, width: "100%" }}> */}

            {/* Close */}
            <button onClick={() => setSelected(null)} style={{
              position: "absolute", top: 20, right: 10,
              background: "none", border: "none", color: "#fff", fontSize: 24, cursor: "pointer",
            }}>✕</button>
                
            {/* Prev */}
            <button onClick={() => navigate(-1)} style={{
              position: "absolute", left: -50, top: "50%", transform: "translateY(-50%)",
              background: "none", border: "none", color: "#fff", fontSize: 36, cursor: "pointer",
            }}>‹</button>

            <img className="event_gallery_image"
              src={selected.url}
              alt={selected.caption}
              style={{  width: "90%", maxHeight: "60vh", objectFit: "contain" }}
            />

            {/* Next */}
            <button onClick={() => navigate(1)} style={{
              position: "absolute", right: -40, top: "50%", transform: "translateY(-50%)",
              background: "none", border: "none", color: "#fff", fontSize: 36, cursor: "pointer",
            }}>›</button>

            {/* <p style={{ textAlign: "center", color: "#ccc", marginTop: 12 }}>{selected.caption}</p> */}
          </div>
        </div>
      )}
    </div>
  );
}
